import { render } from "./ColourPanelView.vue?vue&type=template&id=63492ea2"
import script from "./ColourPanelView.vue?vue&type=script&lang=js"
export * from "./ColourPanelView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__